import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Spin, Select } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';
import { useHistory, useParams } from 'react-router';
import {
  useGetAllPackagesQuery,
  useGetConvertedCurrencyMutation,
  useGetPackagesDetailsByIdQuery,
  useGetQuoteDetailsByIdQuery,
} from './packageSlice';

import mainlake from './ManagePackage.js/images/exotic_main_lake.png';
import exoticLogo from '../../../assets/images/Logos/exotic-fishing-logo.png';
import paymentBanner from './assets/online-payment-options-banner.png';
import applePay from './assets/apple-pay 1.svg';
import EFTpdf from './assets/eft_holiday.pdf';
import masterCard from './assets/card 1.svg';
import visacard from './assets/visa 1.svg';
import maestrocard from './assets/Maestro_2016 1.svg';
import uk from './assets/flags/united-kingdom 1.svg';
import Malaysian from './assets/flags/flag 1.svg';
import cz from './assets/flags/czech-republic 1.svg';
import russia from './assets/flags/russia 1.svg';
import thai from './assets/flags/thai.svg';
import norway from './assets/flags/norway.svg';
import italy from './assets/flags/italy 1.svg';
import france from './assets/flags/france.svg';
import spain from './assets/flags/spain 1.svg';
import poland from './assets/flags/poland 1.svg';
import swedan from './assets/flags/swedan.svg';
import finland from './assets/flags/finland 1.svg';
import estonia from './assets/flags/estonia 1.svg';
import germany from './assets/flags/german 1.svg';
import china from './assets/flags/china 1.svg';
import singapore from './assets/flags/singapore 1.svg';
import denmark from './assets/flags/denmark 1.svg';
import romania from './assets/flags/romania.svg';
import netherland from './assets/flags/netherland.svg';
import opayo from './assets/opayo.svg';
import shield from './assets/shield.svg';
import dayjs from 'dayjs';
import PaymentPage, {
  PaymentProvider,
} from '../components/payment_page/PaymentPage';
import BookingSuccessScreen from '../components/booking_success/components/BookingSuccessScreen';
import { useGetUserQuery } from '../../user_profile/userProfileSlice';
import PaymentFailure from '../components/payment_page/PaymentFailure';
import { useGetFisheryQuery } from '../../fishery_profile/fisherySlice';
import moment from 'moment';
import Moment from 'moment';
import { usePostReservationBookingMutation } from '../../admin/components/quote/quotesSlice';
import { Helmet } from 'react-helmet';
import { languageTranslation } from '../../../lang';
import { useFlags } from 'flagsmith/react';
import { usePaymentProviderFlags } from '../../../utils/hooks';

export const languages = [
  { name: 'English', flag: uk, code: 'en-GB' },
  { name: 'Malaysi', flag: Malaysian, code: 'ms' },
  { name: 'Czech', flag: cz, code: 'cs' },
  { name: 'русский', flag: russia, code: 'ru' },
  { name: 'ไทย', flag: thai, code: 'th' },
  { name: 'Norsk', flag: norway, code: 'no' },
  { name: 'Italiano', flag: italy, code: 'it' },
  { name: 'Français', flag: france, code: 'fr' },
  { name: 'Español', flag: spain, code: 'es' },
  { name: 'Polska', flag: poland, code: 'pl' },
  { name: 'Svenska', flag: swedan, code: 'sv' },
  { name: 'Suomi', flag: finland, code: 'fi' },
  { name: 'Eesti', flag: estonia, code: 'et' },
  { name: 'Deutsch', flag: germany, code: 'de' },
  { name: '中国人', flag: china, code: 'zh' },
  { name: 'Singaporean', flag: singapore, code: 'en-SG' },
  { name: 'Dansk', flag: denmark, code: 'da' },
  { name: 'Română', flag: romania, code: 'ro' },
  { name: 'Nederlands', flag: netherland, code: 'nl' },
];
function QuoteBooking() {
  const fisheryId = useParams()['fishery_id'];
  const ReservationId = useParams()['quote_id'];
  const { data: accountDetails } = useGetUserQuery();
  const { data: fisheryData, isLoading: loadingFisheryData } =
    useGetFisheryQuery(fisheryId);
  const [current, setCurrent] = useState('booking');
  const [reservationExpiryTime, setReservationExpiryTime] = useState();
  const [bookingData, setBookingData] = useState(null);
  const [paymentFailureData, setPaymentFailureData] = useState(null);
  const [currency, setCurrency] = useState('');
  const [priceLoading, setPriceLoading] = useState(true);
  const [language, setLanguage] = useState('en-GB');
  const [convertedCost, setConvertedCost] = useState({
    totalPrice: 0,
    deposit: 0,
  });
  const history = useHistory();
  const [convertCurrency, { isLoading: ConvertLoading }] =
    useGetConvertedCurrencyMutation();
  const { data: packages, isLoading: packageDetailLoading } =
    useGetQuoteDetailsByIdQuery(
      { package_id: ReservationId },
      {
        skip: !fisheryId && !ReservationId,
      }
    );
  const { data: AllPackages, isLoading: packagesLoading } =
    useGetAllPackagesQuery(fisheryId, {
      skip: !fisheryId,
    });

  const {
    paymentProvider,
    applePayEnabled,
    storedCardsEnabled,
    isLoading: providerLoading,
  } = usePaymentProviderFlags({
    fisheryPublicId: fisheryData?.public_id ?? fisheryId ?? null,
    loadingFisheryId: loadingFisheryData,
    paymentType: 'OnlineBookingPayment',
  });

  let Package = packages?.message;

  const totalRoomsBooked = Package?.accommodation_details.reduce(
    (acc, room) => acc + room.quantity,
    0
  );
  let CurrencyList = [
    { code: 'GBP', name: 'British Pound Sterling', symbol: '£' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'USD', name: 'United States Dollar', symbol: '$' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿' },
  ];
  const [currencySymbol, setCurrencySymbol] = useState('');

  const countryOptions = CurrencyList?.sort(({ code: x }, { code: y }) =>
    x === 'GBP' ? -1 : y === 'GBP' ? 1 : 0
  )?.map(({ code, name }) => ({
    label: (
      <span>
        {name} ({code})
      </span>
    ),
    value: code,
  }));

  const languageOptions = languages?.map(({ code, name, flag }) => ({
    label: (
      <span>
        <span>
          <img src={flag} width={14} alt='' className='mg-right-5' />
        </span>
        <span className='txt-underline sb-blue-500'>{name}</span>
      </span>
    ),
    value: code,
  }));
  useEffect(() => {
    setTimeout(() => {
      setCurrency('GBP');
      setCurrencySymbol(CurrencyList.find((i) => i.code === 'GBP')?.symbol);
    }, 1000);
  }, []);
  useEffect(() => {
    if (Package && fisheryData) {
      convertCurrency({
        amount: Package?.deposit,
        currency_from: fisheryData?.currency,
        currency_to: currency,
      })
        .unwrap()
        .then((v) => {
          setPriceLoading(false);
          setConvertedCost((prev) => ({
            ...prev,
            deposit: v,
          }));
        });

      convertCurrency({
        amount: Package?.total_price,
        currency_from: fisheryData?.currency,
        currency_to: currency,
      })
        .unwrap()
        .then((v) => {
          setConvertedCost((prev) => ({
            ...prev,
            totalPrice: v,
          }));
        });
    }
  }, [currency, Package, fisheryData]);
  const [postBooking, { isLoading: postLoading }] =
    usePostReservationBookingMutation();

  const postBookingRequest = () => {
    let payload = {
      arrival_timestamp: Package.check_in_date || '',
      departure_timestamp: Package.check_out_date || '',
      guest: Package.accommodation_users?.no_of_adults || 0,
      anglers: Package.fishing_details?.number_of_anglers || 0,
      accommodation_users: Package?.accommodation_users,
      amount: Package.deposit || 0,
      total_price: Package.total_price || 0,
      lake_id: Package.fishing_lake || '',
      accommodation_lake_id: Package.accommodation_lake || '',
      is_admin_booking_or_editing: false,
      swims: [], // You can fill this if data exists in packages
      details: {
        angler_details: [
          {
            first_name: Package.angler_information?.first_name || '',
            title: Package.angler_information?.title || '',
            nationality: Package.angler_information?.nationality || '',
            last_name: Package.angler_information?.last_name || '',
            email: Package.angler_information?.email || '',
            phone_number: Package.angler_information?.phone_number || '',
            note: '', // Add note if available in API
          },
        ],
      },
      payment_type: '',
      notes: Package?.notes || '',
      book_lake_exclusive: false,
      use_wallet: false,
      wallet_amount_to_spend: 0,
      add_on_details: Package.add_ons || [],
      type: 'package',
      quote_id: Package.id,
      has_accommodation: Package.has_accommodation,
      accommodation_details:
        Package.accommodation_details
          ?.filter((room) => room.quantity > 0)
          ?.map((room) => ({
            ticket_type_id: room.ticket_type_id,
            ticket_type_name: room.ticket_type_name,
            quantity: room.quantity,
            arrival_date:
              (dayjs(Package?.check_in_date).isValid() &&
                dayjs(Package?.check_in_date).format('YYYY-MM-DD')) ||
              '',
            departure_date:
              (dayjs(Package?.check_out_date).isValid() &&
                dayjs(Package?.check_out_date).format('YYYY-MM-DD')) ||
              '',
          })) || [],
      supports_fishing: Package.supports_fishing,
      custom_properties: Package.custom_properties || [],
      taxi_information: {
        taxi_booked: Package.taxi_information?.taxi_booked || false,
        pickup_date: Package.taxi_information?.pickup_date || '',
        pickup_location: Package.taxi_information?.pickup_location || '',
        dropoff_date: Package.taxi_information?.dropoff_date || '',
        dropoff_location: Package.taxi_information?.dropoff_location || '',
      },
      fishing_details: {
        fishing_dates: Package.fishing_details?.fishing_dates || [],
        number_of_fishing_days:
          Package.fishing_details?.number_of_fishing_days || 0,
        number_of_swims: Package.fishing_details?.number_of_swims || 0,
        number_of_guests: Package.fishing_details?.number_of_guests || 0,
        number_of_anglers: Package.fishing_details?.number_of_anglers || 0,
      },
    };

    postBooking(payload)
      .unwrap()
      .then((v) => {
        setBookingData(v);
        setReservationExpiryTime(Moment(moment.now()).add(15, 'minutes'));
        setCurrent('payment');
      });
  };
  const formatDatesByMonth = (dates) => {
    const suffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    const sortedDates = dates?.map((d) => dayjs(d)).sort((a, b) => a - b);

    const grouped = {};

    sortedDates?.forEach((date) => {
      const month = date.format('MMMM');
      const day = `${date.date()}${suffix(date.date())}`;
      if (!grouped[month]) grouped[month] = [];
      grouped[month].push(day);
    });

    return Object.entries(grouped)
      .map(([month, days]) => `${days.join(', ')} ${month}`)
      .join(' - ');
  };

  const activeLanguage = languageTranslation[language];

  return (
    <div>
      <Helmet>
        <meta charSet='utf-8' />
        <meta
          name='description'
          content='Angling Information, fishing tips & tricks, tackle giveaways and angling competitions. All available via swimbooker’s angling social.'
        />
        <title>Review Your Quote | swimbooker</title>
      </Helmet>
      <Row className='exotic-header' align='middle'>
        <Col xs={24} sm={24} md={8} className=''>
          <img
            src={exoticLogo}
            alt='Exotic Fishing Thailand'
            className='logo'
          />
        </Col>
        <Col xs={24} sm={24} md={16} className='partner-logo'>
          <div className='row-center gap-1r justify-end flex-wrap'>
            <div className='row-center justify-between mg-right-0'>
              <div className='fs-13 gSemiBold grey-700 mg-right-10'>
                Language:
              </div>
              <Select
                className='br5 mg-left-10 gBold language-select'
                style={{ width: 150, textAlign: 'left' }}
                value={language}
                onChange={(v) => {
                  setLanguage(v);
                }}
                popupClassName='gBold'
                optionFilterProp='label'
                options={languageOptions}
              />
            </div>
            <div className='row-center justify-between mg-right-20'>
              <div className='fs-13 gSemiBold grey-700 mg-right-10'>
                Select Currency:
              </div>
              <Select
                className='br5 mg-left-10 gBold currency-select'
                style={{ width: 220, textAlign: 'left' }}
                value={currency}
                onChange={(v) => {
                  setCurrency(v);
                  const selected = CurrencyList.find((c) => c.code === v);
                  if (selected) {
                    setCurrencySymbol(selected.symbol);
                  }
                }}
                popupClassName='gBold'
                optionFilterProp='label'
                options={countryOptions}
              />
            </div>

            <div className='justify-end display-flex-column'>
              <div className='fs-10 gBold sb-blue-800'>Powered By:</div>
              <div className='fs-20 gSemiBold lh-1'>
                <span className='sb-blue-500'>swim</span>booker
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className='booking-container'>
        <div style={{ maxWidth: 1400 }} className='mg-auto'>
          {current === 'payment' && (
            <div
              style={{ maxWidth: 800, margin: 'auto' }}
              className='quote-payment-container'
            >
              {providerLoading ? (
                <Spin />
              ) : (
                <PaymentPage
                  idField={{
                    name: 'booking_public_id',
                    value: bookingData?.public_id,
                  }}
                  amount={bookingData?.booking_price?.advance_price}
                  paymentProvider={paymentProvider}
                  billingDetails={
                    Package?.angler_information
                      ? {
                          name: Package.angler_information?.first_name
                            ? Package.angler_information?.first_name +
                              ' ' +
                              Package.angler_information?.last_name
                            : undefined,
                          email: Package.angler_information?.email,
                        }
                      : {}
                  }
                  enableSaveCard={storedCardsEnabled}
                  enableStoredCards={storedCardsEnabled}
                  enableApplePay={applePayEnabled}
                  setErrorPayment={setPaymentFailureData}
                  onPaymentSuccess={() => setCurrent('success')}
                  onPaymentFailure={() => {
                    if (
                      paymentProvider === PaymentProvider.STRIPE ||
                      paymentProvider === PaymentProvider.RYFT
                    ) {
                      return;
                    }
                    setCurrent('failure');
                  }}
                  title={fisheryData?.venue_name}
                  headerContent={
                    <p>
                      <span className={'gSemiBold fs-19'}>Booking ID:</span>{' '}
                      {bookingData?.public_id?.split('_')[1]}
                    </p>
                  }
                  paymentExpiryTime={reservationExpiryTime}
                  onClickCountdownEndedBack={() => {
                    setReservationExpiryTime(Date.now());
                    setCurrent('booking');
                  }}
                />
              )}
            </div>
          )}
          {current === 'success' && (
            <div
              style={{ maxWidth: 1000, margin: 'auto' }}
              className='quote-payment-container'
            >
              <BookingSuccessScreen
                fisheryPublicId={fisheryId}
                bookingId={bookingData?.public_id}
                userId={bookingData?.user_id}
                isInsideWidget={false}
              />
            </div>
          )}
          {current === 'failure' && (
            <div
              style={{ maxWidth: 800, margin: 'auto' }}
              className='quote-payment-container'
            >
              <PaymentFailure
                className={'pd-20 pd-bottom-30 mg-top-30'}
                headerContent={
                  <p>
                    <span className={'gSemiBold black'}>Booking ID:</span>{' '}
                    {bookingData?.public_id?.split('_')[1]}
                  </p>
                }
                errorPayment={paymentFailureData}
                retryPaymentButton={
                  <Button
                    className={
                      'sb-blue-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-top-10 h-fit antd-link-button-override'
                    }
                    onClick={() => {
                      setCurrent('payment');
                      // Show payment page again
                    }}
                  >
                    &lt; Back to payment
                  </Button>
                }
                paymentSuccessfulButton={
                  <Button
                    className={
                      'sb-blue-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-top-10 h-fit antd-link-button-override'
                    }
                    href={`/fishery/${fisheryId}`}

                    //   onClick={() => {
                    //     if (isInsideWidget) {
                    //       sendWidgetMessage({ type: 'widgetCollapse' });
                    //     } else {
                    //       // use href -- do nothing here
                    //     }
                    //   }}
                  >
                    &lt; Back to profile
                  </Button>
                }
              />
            </div>
          )}

          {current === 'booking' &&
            (packageDetailLoading || priceLoading ? (
              <div className='mg-auto center w-full' style={{ marginTop: 150 }}>
                <Spin />
              </div>
            ) : (
              <Row className='w-full quote-container gap-1r'>
                <Col xs={24} sm={24} md={13} lg={16} className='mg-top-30'>
                  <div className='quote-image'>
                    <img src={mainlake} alt='Exotic Fishing Thailand' />
                    <div className='gradient'></div>
                    <div className='quote-title'>{fisheryData?.venue_name}</div>
                  </div>
                  <div className='quote-details-container details'>
                    <Row className='package-row '>
                      <Col className='package-content'>
                        <h3 className='package-title mg-bottom-10 fs-24'>
                          {Package?.angler_information?.title}{' '}
                          {Package?.angler_information?.first_name}{' '}
                          {Package?.angler_information?.last_name} -{' '}
                          {activeLanguage?.reservation?.pleaseSeeYour}{' '}
                          {fisheryData?.venue_name}{' '}
                          {activeLanguage?.reservation?.quoteBelow}
                        </h3>
                        {Package?.description ? (
                          <p className='package-description'>
                            {Package?.description}
                          </p>
                        ) : (
                          <p className='package-description'>
                            {activeLanguage.quote_summary?.default_description}{' '}
                            Exotic Fishing Thailand by email on{' '}
                            <a href='mailto:reservations@exoticfishingthailand.com'>
                              reservations@exoticfishingthailand.com
                            </a>
                          </p>
                        )}
                        <p className='package-description'>
                          {activeLanguage.quote_summary?.holidayInfoNote}{' '}
                          <span
                            onClick={() =>
                              window.open(
                                'https://swimbooker-fishery-details.s3.eu-west-2.amazonaws.com/eft_holiday.pdf',
                                '_blank'
                              )
                            }
                            className='gBold txt-underline cp'
                          >
                            here
                          </span>
                        </p>

                        <Row
                          gutter={[10, 10]}
                          className='details-package-features'
                        >
                          {Package?.included_benefits
                            ?.filter((b) => b.selected)
                            .map((benefit) => (
                              <Col xs={12} sm={8}>
                                <div className='feature-item'>
                                  <img
                                    src={calendarIcon}
                                    width={14}
                                    height={14}
                                    alt='benefit'
                                    className='mg-right-5'
                                  />{' '}
                                  {benefit?.customText
                                    ? benefit?.customText
                                    : benefit?.label}
                                </div>
                              </Col>
                            ))}
                          {Package?.other_benefits?.data
                            ?.filter((b) => b.selected)
                            .map((benefit) => (
                              <Col xs={12} sm={8}>
                                <span className='feature-item'>
                                  <img
                                    src={calendarIcon}
                                    width={14}
                                    height={14}
                                    alt='benefit'
                                    className='mg-right-5'
                                  />{' '}
                                  {benefit?.name}
                                </span>
                              </Col>
                            ))}
                        </Row>

                        <div className='package-pricing'>
                          <div className='package-details-price-container mg-bottom-10 flex-wrap gap-05r row-center justify-between'>
                            <span className='package-price-label uppercase  font-montserrat sb-blue-700'>
                              {activeLanguage?.quote_summary?.your_quote}
                            </span>
                            <div
                              className='package-price  sb-blue-bg-100 font-montserrat txt-center sb-blue-700'
                              style={{ minWidth: 205 }}
                            >
                              {ConvertLoading ? (
                                <Spin />
                              ) : (
                                `${currency} ${
                                  convertedCost?.totalPrice ??
                                  Package?.total_price?.toFixed(2)
                                }`
                              )}
                            </div>
                          </div>
                          <div className='package-details-price-container flex-wrap gap-05r row-center justify-between'>
                            <span className='package-price-label uppercase   font-montserrat sb-blue-700'>
                              {activeLanguage?.quote_summary?.pay_today}
                            </span>
                            <div
                              className='package-price  sb-blue-bg-100 txt-center font-montserrat sb-blue-700'
                              style={{ minWidth: 205 }}
                            >
                              {ConvertLoading ? (
                                <Spin />
                              ) : (
                                `${currency} ${
                                  convertedCost?.deposit ??
                                  Package?.deposit?.toFixed(2)
                                }`
                              )}
                            </div>
                          </div>
                        </div>

                        {Package?.booking_status !== 'pending' && (
                          <div className='fs-24 gBold mg-top-20 txt-center'>
                            {activeLanguage?.quote_summary?.quote_expired}
                          </div>
                        )}
                        {Package?.booking_status === 'pending' && (
                          <>
                            <Button
                              className='details-book-button uppercase'
                              onClick={postBookingRequest}
                            >
                              {activeLanguage?.quote_summary?.accept_quote}
                            </Button>
                            {fisheryData?.currency !== 'GBP' && (
                              <div className='fs-14 gMedium sb-blue-500 txt-center mg-top-15'>
                                {activeLanguage?.quote_summary?.conversion_note}
                              </div>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div
                    className='row-center justify-center gap-1r bg-white pd-10 mg-top-20 flex-wrap'
                    style={{ borderRadius: 16 }}
                  >
                    <div className='safe-checkout-label fs-20 sb-blue-700 gBold row-center'>
                      <img
                        src={shield}
                        alt='apple-pay'
                        width={28}
                        className='mg-right-10'
                      />
                      {activeLanguage?.quote_summary?.safe_checkout}
                    </div>
                    <div className='safe-checkout-divider'></div>
                    <div className='safe-checkout-icons flex-wrap'>
                      <img src={applePay} alt='apple-pay' width={42} />
                      <img src={visacard} alt='visa' width={42} />
                      <img src={masterCard} alt='master-card' width={26} />
                      <img src={maestrocard} alt='maestro' width={26} />
                      <img src={opayo} alt='opayo' width={45} />
                    </div>
                  </div>
                  <div
                    className='row-center justify-center gap-1r bg-white pd-15 mg-top-20 flex-wrap'
                    style={{ borderRadius: 16 }}
                  >
                    <div className='sb-blue-500 fs-13 gMedium'>
                      {activeLanguage?.quote_summary?.availability_note}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={10} lg={7}>
                  <div className='quote-summary w-full'>
                    <div className='quote-heading mg-bottom-20'>
                      {activeLanguage?.quote_summary?.quote_summary}
                    </div>
                    <div className='summary-details'>
                      <Row className='summary-section gSemiBold sb-blue-900 '>
                        <Col
                          span={24}
                          className='row-center justify-between mg-bottom-15 fs-16 '
                        >
                          <div>
                            {
                              activeLanguage?.quote_summary
                                ?.accommodation_included
                            }
                            :
                          </div>
                          <div>
                            {Package?.has_accommodation
                              ? activeLanguage?.reservation?.taxi?.yes
                              : activeLanguage?.reservation?.taxi?.no}
                          </div>
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_adults}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.accommodation_users?.no_of_adults}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_children}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.accommodation_users?.no_of_children}
                        </Col>
                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_teens}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.accommodation_users?.no_of_teens}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_rooms}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {totalRoomsBooked}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.arrival_date}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {dayjs(Package?.check_in_date).isValid() &&
                            dayjs(Package?.check_in_date).format('DD/MM/YYYY')}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.departure_date}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {dayjs(Package?.check_out_date).isValid() &&
                            dayjs(Package?.check_out_date).format('DD/MM/YYYY')}
                        </Col>
                      </Row>

                      <Row className='summary-section gSemiBold sb-blue-900 '>
                        <Col
                          span={24}
                          className='row-center justify-between mg-bottom-15 fs-16 '
                        >
                          <div>
                            {activeLanguage?.quote_summary?.fishing_included}:
                          </div>
                          <div>
                            {Package?.supports_fishing
                              ? activeLanguage?.reservation?.taxi?.yes
                              : activeLanguage?.reservation?.taxi?.no}
                          </div>
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_anglers}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.fishing_details?.number_of_anglers ?? 0}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_swims}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.fishing_details?.number_of_swims}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.no_of_fishing_days}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.fishing_details?.number_of_fishing_days}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.fishing_dates}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {formatDatesByMonth(
                            Package?.fishing_details?.fishing_dates
                          )}
                        </Col>
                      </Row>

                      <Row className='summary-section gSemiBold sb-blue-900 '>
                        <Col
                          span={24}
                          className='row-center justify-between mg-bottom-15 fs-16 '
                        >
                          <div>
                            {activeLanguage?.quote_summary?.taxis_included}:
                          </div>
                          <div>
                            {Package?.taxi_information?.taxi_booked
                              ? activeLanguage?.reservation?.taxi?.yes
                              : activeLanguage?.reservation?.taxi?.no}
                          </div>
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.pick_up_date_and_time}
                          :
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {dayjs(
                            Package?.taxi_information?.pickup_date
                          ).isValid() &&
                            dayjs(Package?.taxi_information?.pickup_date)
                              .add(30, 'minute')
                              .startOf('hour')
                              .format('ha | DD/MM/YYYY')}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.pick_up_location}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.taxi_information?.pickup_location}
                        </Col>

                        <Col className='details' span={12}>
                          {
                            activeLanguage?.quote_summary
                              ?.drop_off_date_and_time
                          }
                          :
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {dayjs(
                            Package?.taxi_information?.dropoff_date
                          ).isValid() &&
                            dayjs(Package?.taxi_information?.dropoff_date)
                              .add(30, 'minute')
                              .startOf('hour')
                              .format('ha | DD/MM/YYYY')}
                        </Col>

                        <Col className='details' span={12}>
                          {activeLanguage?.quote_summary?.drop_off_location}:
                        </Col>
                        <Col span={12} className='summary-value details'>
                          {Package?.taxi_information?.dropoff_location}
                        </Col>
                      </Row>

                      <Row className='summary-section gSemiBold sb-blue-900 '>
                        <Col
                          span={24}
                          className='row-center justify-between mg-bottom-15 fs-16 '
                        >
                          <div>{activeLanguage?.quote_summary?.add_ons}:</div>
                          <div>
                            {Package?.add_ons?.length
                              ? activeLanguage?.reservation?.taxi?.yes
                              : activeLanguage?.reservation?.taxi?.no}
                          </div>
                        </Col>
                        {Package?.add_ons?.map((item) => (
                          <Row className='w-full'>
                            <Col className='details' span={18}>
                              {item?.name}
                            </Col>
                            <Col span={6} className='summary-value details'>
                              x{item?.quantity}
                            </Col>
                          </Row>
                        ))}
                      </Row>
                    </div>
                    <div className='price-container'>
                      <div className='price-section sb-blue-900'>
                        <div className='fs-20 gSemiBold center'>
                          {activeLanguage?.quote_summary?.total_price}:
                        </div>
                        <div className='row-center'>
                          <div className='gSemiBold fs-14 mg-right-5'>
                            ({currency} {currencySymbol})
                          </div>
                          <div
                            className='seagreen-bg-700 br5 white txt-right fs-18 gSemiBold pd-left-5 pd-right-5'
                            style={{ minWidth: 100 }}
                          >
                            {ConvertLoading ? (
                              <Spin />
                            ) : (
                              convertedCost?.totalPrice ??
                              Package?.total_price ??
                              0
                            )}
                          </div>
                        </div>
                      </div>

                      <div className='price-section sb-blue-900'>
                        <div className='fs-20 gSemiBold center'>
                          {activeLanguage?.quote_summary?.pay_today}:
                          <div className='fs-12 gSemiBold'>
                            ({activeLanguage?.quote_summary?.deposit_perc})
                          </div>
                        </div>
                        <div className='row-center'>
                          <div className='gSemiBold fs-14 mg-right-5'>
                            ({currency} {currencySymbol})
                          </div>
                          <div
                            className='seagreen-bg-500 br5 white txt-right fs-18 gSemiBold pd-left-5 pd-right-5'
                            style={{ minWidth: 100 }}
                          >
                            {ConvertLoading ? (
                              <Spin />
                            ) : (
                              convertedCost?.deposit ?? Package?.deposit ?? 0
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            ))}
        </div>
      </div>
    </div>
  );
}

export default QuoteBooking;
